export const prices = {

	data () {
		return {
		}
	},
	computed: {
		totalPrice () {
			if (!this.order) return
			return (this.order.prices.net - this.edenredTransaction).toFixed(2)
		},

		orderHasDiscount () {
			if (!this.order) return
			return this.order && this.order.prices.discount > 0
		},

		edenredTransaction () {
			return this.order && this.order.transactions && this.order.transactions.edenred
		},

		orderHasEdenred () {
			if (!this.order) return
			return this.order && this.order.transactions && this.order.transactions.edenred !== null
		},

		deliveryPrice () {
			if (!this.order) return

			if (this.order.prices.delivery > 0) {
				return '€ ' + this.order.prices.delivery.replace('.', ',')
			}
			return 'gratuita'
		}
	}
}
